import React from "react";
import { Dialog, Button } from "@material-ui/core";
import type {ModalState} from '../../redux/reducers/modalReducer';
import {useDispatch, useSelector} from 'react-redux';
import {closeModal} from '../../redux/reducers/modalReducer';

const ConfirmModal = () => {
  const dispatch = useDispatch();
  const {open, message, title, style, onOk}: ModalState = useSelector(s => s['modal']);
  return (
    <Dialog
      maxWidth="xs"
      fullWidth={true}
      open={open && style === 'confirm'}
      onClose={() => {}}
    >
      <div className="p-24">
        <h4 className="capitalize">{title ?? 'confirm'}</h4>
        <p>{message}</p>
        <div className="flex flex-space-between pt-8">
          <Button onClick={() => {onOk(); closeModal(dispatch)}} variant="contained" color="primary">Yes</Button>
          <Button onClick={() => closeModal(dispatch)} variant="contained" color="secondary"><span className={'text-white'}>No</span></Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;
